import React from 'react'

import { ScheduledCommunicationTemplateList } from '@/types/ScheduledCommunicationTemplate'

type Props = {
  scheduledCommunicationTemplate: ScheduledCommunicationTemplateList
}

const MobileScheduledCommunicationTemplateCard = ({ scheduledCommunicationTemplate }: Props) => {
  return (
    <div className="mb-4 w-full overflow-hidden rounded-md border border-border-primary p-4 shadow-md">
      <div className="mb-2 flex justify-between">
        <p className="flex-none text-sm text-grey-500">Scheduled Communication Template ID</p>
        <p className="ml-3 flex-1 text-right text-sm" style={{ fontWeight: 'bold' }}>
          {scheduledCommunicationTemplate.id}
        </p>
      </div>
      <div className="flex justify-between">
        <p className="flex-none text-sm text-grey-500">Content</p>
        <p className="ml-3 flex-1 text-right text-sm">{scheduledCommunicationTemplate.content}</p>
      </div>
    </div>
  )
}
export default MobileScheduledCommunicationTemplateCard
